/**
 * Pipe-delimited synthetic universe RAW string (plan §0.3).
 * Format: SECTOR|TICKER|NAME|MCAP_B|PE|DIV|REV_B
 * Provenance: demos/Meridian Terminal.dc.html — do not reformat (golden digest).
 * Sole data source for the demo universe; size-gate exempt per ADR-0014, which
 * prices the waiver at "exports no function, carries a provenance header".
 */
export const UNIVERSE_RAW = `TEC|AAPL|Apple|3410|34|0.4|391
TEC|MSFT|Microsoft|3280|36|0.7|270
TEC|NVDA|NVIDIA|3020|48|0.0|130
TEC|AVGO|Broadcom|1180|42|1.2|51
TEC|ORCL|Oracle|520|38|0.9|55
TEC|CRM|Salesforce|305|44|0.6|38
TEC|AMD|Advanced Micro Devices|248|52|0.0|26
TEC|ADBE|Adobe|196|29|0.0|21
TEC|CSCO|Cisco Systems|232|24|2.7|54
TEC|INTC|Intel|94|0|0.0|53
TEC|QCOM|Qualcomm|186|17|2.0|39
TEC|TXN|Texas Instruments|172|33|2.6|16
TEC|MU|Micron Technology|118|21|0.5|29
TEC|AMAT|Applied Materials|148|21|0.9|27
TEC|INTU|Intuit|178|56|0.6|16
TEC|IBM|IBM|206|31|3.1|63
TEC|NOW|ServiceNow|198|130|0.0|11
TEC|PANW|Palo Alto Networks|122|48|0.0|8
TEC|ANET|Arista Networks|132|44|0.0|7
TEC|LRCX|Lam Research|96|24|1.1|15
COM|GOOGL|Alphabet|2140|24|0.5|350
COM|META|Meta Platforms|1380|27|0.4|165
COM|NFLX|Netflix|380|43|0.0|39
COM|DIS|Walt Disney|202|21|0.9|91
COM|TMUS|T-Mobile US|248|24|1.5|81
COM|CMCSA|Comcast|148|9|3.3|122
COM|VZ|Verizon Communications|178|9|6.4|134
COM|T|AT&T|158|13|4.9|122
COM|EA|Electronic Arts|38|33|0.5|7
COM|WBD|Warner Bros. Discovery|26|0|0.0|39
DIS|AMZN|Amazon|2280|38|0.0|638
DIS|TSLA|Tesla|790|92|0.0|98
DIS|HD|Home Depot|392|26|2.3|155
DIS|MCD|McDonald's|212|25|2.3|26
DIS|NKE|Nike|112|22|2.0|49
DIS|SBUX|Starbucks|104|32|2.5|36
DIS|BKNG|Booking Holdings|168|31|0.8|24
DIS|LOW|Lowe's|142|21|1.9|84
DIS|TJX|TJX Companies|138|28|1.3|56
DIS|ABNB|Airbnb|84|38|0.0|11
DIS|MAR|Marriott International|76|26|1.0|25
DIS|GM|General Motors|54|6|1.1|187
DIS|F|Ford Motor|42|9|5.5|176
STA|WMT|Walmart|728|38|0.9|681
STA|PG|Procter & Gamble|392|26|2.4|84
STA|KO|Coca-Cola|272|24|3.1|46
STA|PEP|PepsiCo|206|20|3.6|92
STA|COST|Costco Wholesale|404|52|0.5|255
STA|PM|Philip Morris International|188|22|4.1|37
STA|MDLZ|Mondelez International|82|21|2.9|36
STA|CL|Colgate-Palmolive|74|25|2.2|20
STA|MO|Altria Group|92|10|7.4|20
STA|KHC|Kraft Heinz|34|11|5.4|26
FIN|BRK.B|Berkshire Hathaway|1010|13|0.0|371
FIN|JPM|JPMorgan Chase|692|13|2.0|166
FIN|V|Visa|610|31|0.7|36
FIN|MA|Mastercard|486|38|0.5|28
FIN|BAC|Bank of America|338|14|2.4|96
FIN|WFC|Wells Fargo|242|14|2.3|78
FIN|GS|Goldman Sachs|182|16|2.2|53
FIN|MS|Morgan Stanley|206|17|3.0|61
FIN|AXP|American Express|198|21|1.0|66
FIN|SCHW|Charles Schwab|142|24|1.4|19
FIN|BLK|BlackRock|152|23|2.1|20
FIN|C|Citigroup|138|11|3.1|81
FIN|PYPL|PayPal|76|17|0.0|32
HLT|LLY|Eli Lilly|742|68|0.6|45
HLT|UNH|UnitedHealth Group|498|18|1.6|400
HLT|JNJ|Johnson & Johnson|372|24|3.1|88
HLT|ABBV|AbbVie|318|58|3.2|56
HLT|MRK|Merck & Co.|252|22|2.9|64
HLT|TMO|Thermo Fisher Scientific|198|31|0.3|43
HLT|ABT|Abbott Laboratories|196|34|1.8|41
HLT|PFE|Pfizer|150|17|6.2|59
HLT|AMGN|Amgen|148|34|3.2|33
HLT|DHR|Danaher|166|42|0.5|24
HLT|ISRG|Intuitive Surgical|182|78|0.0|8
HLT|GILD|Gilead Sciences|114|22|3.4|28
HLT|VRTX|Vertex Pharmaceuticals|118|0|0.0|11
HLT|REGN|Regeneron Pharmaceuticals|76|17|0.0|13
HLT|MDT|Medtronic|112|27|3.2|33
IND|CAT|Caterpillar|186|18|1.5|65
IND|GE|GE Aerospace|196|38|0.6|39
IND|RTX|RTX Corporation|158|26|2.1|81
IND|HON|Honeywell International|138|23|2.1|38
IND|UNP|Union Pacific|142|22|2.2|24
IND|BA|Boeing|122|0|0.0|73
IND|DE|Deere & Company|112|17|1.4|51
IND|LMT|Lockheed Martin|118|18|2.7|71
IND|UPS|United Parcel Service|108|17|5.1|91
IND|MMM|3M|72|17|2.0|24
IND|ADP|Automatic Data Processing|118|30|2.0|19
IND|CSX|CSX Corporation|64|18|1.4|14
IND|EMR|Emerson Electric|68|32|1.7|17
ENE|XOM|Exxon Mobil|472|14|3.4|340
ENE|CVX|Chevron|278|15|4.3|193
ENE|COP|ConocoPhillips|118|12|3.1|57
ENE|SLB|SLB|56|11|2.9|36
ENE|EOG|EOG Resources|66|10|3.3|24
ENE|PSX|Phillips 66|48|14|3.9|143
ENE|MPC|Marathon Petroleum|46|13|2.3|140
ENE|VLO|Valero Energy|40|12|3.4|130
ENE|OXY|Occidental Petroleum|42|17|2.1|27
ENE|WMB|Williams Companies|66|32|3.4|10
ENE|KMI|Kinder Morgan|62|24|4.1|15
UTL|NEE|NextEra Energy|146|21|3.0|25
UTL|DUK|Duke Energy|88|19|3.6|30
UTL|SO|Southern Company|98|22|3.2|26
UTL|SRE|Sempra|56|17|3.1|17
UTL|AEP|American Electric Power|56|18|3.5|20
UTL|D|Dominion Energy|46|24|4.6|15
UTL|EXC|Exelon|44|17|3.6|23
UTL|XEL|Xcel Energy|40|19|3.3|14
REI|PLD|Prologis|108|36|3.4|8
REI|AMT|American Tower|92|32|3.2|11
REI|EQIX|Equinix|88|78|2.1|9
REI|SPG|Simon Property Group|62|22|4.9|6
REI|O|Realty Income|52|52|5.6|5
REI|CCI|Crown Castle|42|32|6.1|7
REI|PSA|Public Storage|52|28|4.1|5
REI|WELL|Welltower|76|68|2.1|8
MAT|LIN|Linde|212|33|1.3|33
MAT|SHW|Sherwin-Williams|88|33|0.8|23
MAT|APD|Air Products & Chemicals|64|24|2.4|12
MAT|FCX|Freeport-McMoRan|58|32|0.8|26
MAT|NEM|Newmont|54|15|2.1|19
MAT|ECL|Ecolab|68|38|0.9|16
MAT|DOW|Dow Inc.|28|22|7.2|43
MAT|NUE|Nucor|30|18|1.5|31`;
